import { Button, Center, Loader, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

/** Centered spinner for the whole viewport (session check, initial route load). */
export function FullPageLoader() {
  return (
    <Center h="100dvh" bg="gray.0">
      <Loader size="md" />
    </Center>
  );
}

interface FullPageMessageProps {
  title: ReactNode;
  text?: ReactNode;
  actionLabel?: ReactNode;
  onAction?: () => void;
}

/** Full-viewport message with an optional action (connection lost, fatal route error). */
export function FullPageMessage({ title, text, actionLabel, onAction }: FullPageMessageProps) {
  return (
    <Center h="100dvh" bg="gray.0" p="md">
      <Stack align="center" gap="sm" maw={420} ta="center">
        <ThemeIcon size={48} radius="xl" variant="light" color="orange">
          <IconAlertTriangle size={26} stroke={1.6} />
        </ThemeIcon>
        <Title order={3}>{title}</Title>
        {text && <Text c="dimmed">{text}</Text>}
        {actionLabel && onAction && (
          <Button mt="xs" onClick={onAction}>
            {actionLabel}
          </Button>
        )}
      </Stack>
    </Center>
  );
}
